import { AtoZTheme } from '@amzn/atoz-web/Theme';

export const appWebTheme = {
    ...AtoZTheme,
    constants: {
        ...AtoZTheme.constants,
        // Match ESSPortal max width
        maxWidth: 1140
    }
};
